import React from 'react'
import styled from 'styled-components';

import { mediaMax } from '@styles/sizes';

import Container from '../Container/Container'

const StyledTestimonial = styled.div`
  background: #F1F5F2;
  padding: 80px;
  margin-top: 40px;
  ${mediaMax.tablet`
    padding: 40px;
` }
`;

const StyledTestimonialWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
  position: relative;
`;

const StyledTestimonialPole = styled.div`
  position: absolute;
  top: -120px;
  width: 2px;
  height: 80px;
  background: #65524D;
  ${mediaMax.tablet`
    display: none;
` }
`

const Testimonial = ({children}) => {
  return (
    <StyledTestimonial>
      <Container>
        <StyledTestimonialWrapper>
          <StyledTestimonialPole/>
          {children}
        </StyledTestimonialWrapper>
      </Container>
    </StyledTestimonial>
  )
}

export default Testimonial
